var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.101,
    height: 29.122,
    viewBox: "0 0 29.101 29.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7564",
    "data-name": "Group 7564",
    transform: "translate(14.757 -8.687) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    x2: 32.262,
    transform: "translate(0.17 17.04)",
    fill: "none",
    stroke: "#734bd1",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    x2: 32.709,
    transform: "translate(16.286 0) rotate(90)",
    fill: "none",
    stroke: "#734bd1",
    strokeLinecap: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.7a258e479acc71a650c1dd977245bb19.svg";
export { ForwardRef as ReactComponent };